module.exports = function() {
  return new Worker(__webpack_public_path__ + "5d7fd4f15c3d03d76e77.worker.js");
};